import { render, staticRenderFns } from "./ShopIndex.vue?vue&type=template&id=f3155bec&scoped=true"
import script from "./ShopIndex.vue?vue&type=script&lang=js"
export * from "./ShopIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3155bec",
  null
  
)

export default component.exports